/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Use_Local_Storage_HelpInputs */

const en_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use local storage when saving project files`)
};

const fr_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser le stockage local lors de l'enregistrement des fichiers de projet`)
};

const de_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwenden Sie den lokalen Speicher zum Speichern von Projektdateien`)
};

const it_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizzare l'archiviazione locale quando si salvano i file di progetto`)
};

const ru_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте локальное хранилище при сохранении файлов проекта.`)
};

const es_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilice el almacenamiento local al guardar archivos de proyecto`)
};

const zh_cn2_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存项目文件时使用本地存储`)
};

const ja_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトファイルを保存するときにローカルストレージを使用する`)
};

const hi_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट फ़ाइलों को सहेजते समय स्थानीय संग्रहण का उपयोग करें।`)
};

const pt_pt2_options_general_use_local_storage_help = /** @type {(inputs: Options_General_Use_Local_Storage_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilize o armazenamento local ao salvar arquivos de projeto.`)
};

/**
* | output |
* | --- |
* | "Use local storage when saving project files" |
*
* @param {Options_General_Use_Local_Storage_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_use_local_storage_help = /** @type {((inputs?: Options_General_Use_Local_Storage_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Use_Local_Storage_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_use_local_storage_help(inputs)
	if (locale === "de") return de_options_general_use_local_storage_help(inputs)
	if (locale === "it") return it_options_general_use_local_storage_help(inputs)
	if (locale === "ru") return ru_options_general_use_local_storage_help(inputs)
	if (locale === "es") return es_options_general_use_local_storage_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_use_local_storage_help(inputs)
	if (locale === "ja") return ja_options_general_use_local_storage_help(inputs)
	if (locale === "hi") return hi_options_general_use_local_storage_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_use_local_storage_help(inputs)
	return en_options_general_use_local_storage_help(inputs)
});